import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
export const useGoodSameList = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGoodSameListcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGoodSameList-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGoodSameList-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useGoodSameList-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const load = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.getSameGoodList(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        result.value = [];
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };

  return {
    load,
    list: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
